import { Toast } from 'mand-mobile';

export default {
  methods: {
    initWs (url) {
      if ('WebSocket' in window) {
        // 打开一个 web socket
        this.ws = new WebSocket(url);

        // ws.onopen = () => {
        //   // Web Socket 已连接上，使用 send() 方法发送数据
        //   ws.send('{"class":1,"type":1,"status":1}');
        //   console.log('数据发送中...');
        // };

        this.ws.onopen = this.onopen;

        this.ws.onmessage = this.onmessage;

        this.ws.onclose = this.onclose;

        this.ws.onerror = this.onerror;
      } else {
        // 浏览器不支持 WebSocket
        Toast.failed('您的浏览器不支持 WebSocket!');
      }
    },
    onopen () {
      //   // Web Socket 已连接上，使用 send() 方法发送数据
      this.resetHeatBeat();
      console.log('onopen...');
    },
    onmessage (evt) {
      console.log('数据已接收...');
      // console.log('evt.data', evt.data);
    },
    onclose () {
      console.log('连接已关闭...');
    },
    onerror () {
      this.ws && this.ws.close();
      console.log('错误...');
    },
    startWsHeartbeat () {
      console.log('startWsHeartbeat1');
      console.log('this.ws', this.ws);
      if (this.ws) {
        console.log('startWsHeartbeat2');
        this.heartBeatTimer && clearInterval(this.heartBeatTimer);
        this.heartBeatTimer = setInterval(() => {
          this.ws.send(JSON.stringify({ cmd: 'index.heartbeat', data: { message: 'ping' } }));
        }, 10000);
      }
    },
    resetHeatBeat () {
      console.log('resetHeatBeat');
      clearInterval(this.heartBeatTimer);
      this.heartBeatTimer = null;
      this.startWsHeartbeat();
    }
  }
};
